import React from "react";
import { observer, inject } from "mobx-react";
import { ProviderBanner } from "ComponentsUI/ProviderBanner";
import SubMenuContainer from "Containers/SubMenuContainer";
import BreadCrumbsContainer from "Containers/BreadCrumbsContainer";
import { generateUrl } from "Services/withDefaultParams";
import images from "Configs/images.config";
import { BottomPart } from "ComponentsUI/Navigation";
import { replaceStaticHost } from "Helpers/ImageManager";

var Routes = require("Configs/routes");

@inject("ApplicationModel")
@observer
export default class ProviderHeaderWrapperContainer extends React.Component {
	onChangeUrl(provider) {
		let {
			ApplicationModel: { tariffsModel },
		} = this.props;
		let orderToHomeUrl = generateUrl(Routes.OrderHome.route, {
			regionUrl: provider.region.url,
		});
		tariffsModel.setProvider(provider);
		this.props.history.push({
			pathname: orderToHomeUrl,
			search: `?provider_id=${provider.id}`,
		});
	}

	componentDidUpdate(prevProps) {
		if (!this.props.providerForCard && !this.props.providerForCard.loading) {
			let url = generateUrl(Routes.Default.route, {
				regionUrl: this.props.match.params.regionUrl,
			});
			this.props.history.push(url);
		}
	}

	render() {
		let isStub = this.props.providerForCard.loading;

		let {
			ApplicationModel: { windowSizeModel, text, routesModel },
		} = this.props;

		routesModel.setProvider(this.props.providerForCard.provider);

		const region = this.props.ApplicationModel.currentRegion;

		let providerImage =
			!!region && !!region.image_lg
				? {
						lg: replaceStaticHost(region.image_lg),
						md: replaceStaticHost(region.image_md),
						sm: replaceStaticHost(region.image_sm),
						xs: replaceStaticHost(region.image_xs),
					}
				: {
						lg: replaceStaticHost(images.heroBannerLg),
						md: replaceStaticHost(images.heroBannerMd),
						sm: replaceStaticHost(images.heroBannerSm),
						xs: replaceStaticHost(images.heroBannerXs),
					};

		let providerData = null;
		let providerLogo = "";
		let orderTypes = [];
		let rating = {};
		let site = "";
		let phone = "";
		let phoneSupport = "";
		let subMenu = <SubMenuContainer stub={isStub} />;
		let header = "";
		let h1After = "";
		let seoData = this.props.seoData;

		if (!isStub) {
			providerData = this.props.providerForCard.provider;

			if (!providerData?.hasOwnProperty("id")) {
				return null;
			}
			if (providerData.hasOwnProperty("logo")) {
				providerLogo = replaceStaticHost(providerData.logo);
			}

			if (providerData.hasOwnProperty("order_types")) {
				orderTypes = providerData.order_types;
			}

			if (providerData.hasOwnProperty("rating")) {
				rating = providerData.rating;
			}

			if (providerData.hasOwnProperty("contacts")) {
				phone = providerData.contacts.phones[0];
				if (!!phone) {
					phone = phone.replace("(", " (").replace(")", ") ");
				}

				phoneSupport = providerData.contacts.phone_support.join(", ");
				site = providerData.contacts.site;
			}
			subMenu = (
				<SubMenuContainer
					provider={providerData}
					news={this.props.providerForCard.news.data}
					actions={this.props.providerForCard.actions.data}
					tariffs={providerData.info.cnt_tariffs}
					map={
						!!providerData.order_types.find((item) => item.id == 1) &&
						!providerData?.sell_self?.provider?.url_name
					}
				/>
			);

			header = this.props.defaultHeader
				? `${this.props.defaultHeader} ${providerData.name}`
				: seoData && seoData.h1;

			h1After = seoData && seoData.h1After;
		}

		let originalProvider = (
			<ProviderBanner
				isStub={isStub}
				text={text}
				breadCrumbs={!isStub ? <BreadCrumbsContainer /> : null}
				background={providerImage}
				providerLogo={providerLogo}
				orderTypes={orderTypes}
				rating={rating}
				phone={phone}
				phoneSupport={phoneSupport}
				site={site}
				windowSizes={windowSizeModel.windowSizes}
				data={providerData}
				notH1={this.props.notH1}
				h1={header}
				h1After={h1After}
			/>
		);

		if (isStub) {
			return (
				<React.Fragment>
					{originalProvider}
					<BottomPart providerTheme={true} whiteTheme={true} />
				</React.Fragment>
			);
		}

		return (
			<React.Fragment>
				{originalProvider}
				<BottomPart providerTheme={true} whiteTheme={true} menu={subMenu} />
			</React.Fragment>
		);
	}
}
